import SiteNav from "./SiteNav";
import SiteFooter from "./SiteFooter";
import { BLACK } from "./kit";

export default function PageShell({ children, testId, disclaimer = false }) {
  return (
    <main className="min-h-screen w-full text-white/85" style={{ background: BLACK }} data-testid={testId}>
      <SiteNav />
      {children}
      <SiteFooter disclaimer={disclaimer} />
    </main>
  );
}
